import React from "react";
import {widgetService} from "../../jwt/_services/landings/widgetService";

export const widgetProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await widgetService.getOptions( customFilter );

        return listItems.map( ({id, code, name}) => ({
                id,
                value: `${code}${name ? ` - ${name}` : ''}`,
                label: <label>{ `${code}${name ? ` - ${name}` : ''}` }</label>
            })
        );
    } catch (error) {
        console.log(error.message)
    }
}